import { useState, useContext, useEffect } from "react";
import validator from "validator";
import axios from "axios";
import Header from "../layout/Header";
import Footer from "../layout/Footer";
import { alertContext } from "../contexts/AlertProvider";
import Alert from "../Alert";

const ProfileSettings = () => {
  const [email, setEmail] = useState("");
  const [emailError, setEmailError] = useState("");
  const [alertConfig, setAlertConfig] = useContext(alertContext);
  const token = localStorage.getItem("token");

  const updateEmail = (event) => {
    event.preventDefault();
    if (email && email.length > 0) {
      if (validator.isEmail(email)) {
        axios
          .post(
            process.env.REACT_APP_API_ENDPOINT + "update-profile",
            {
              email: email,
            },
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          )
          .then((res) => {
            if (res.data.code === 0) {
              setAlertConfig({
                show: true,
                message: res.data.message,
                type: "danger",
              });
            }
            if (res.data.code === 1) {
              setAlertConfig({
                show: true,
                message: res.data.message,
                type: "success",
              });
              profileDetails();
            }
          })
          .catch((err) => {
            console.log(err);
          });
      } else {
        setEmailError("Invalid Email Address");
      }
    } else {
      setEmailError("Please Enter Email");
    }
  };
  const profileDetails = () => {
    axios
      .post(
        process.env.REACT_APP_API_ENDPOINT + "profile-details",
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((res) => {
        if (res.data.code === 0) {
          setAlertConfig({
            show: true,
            message: res.data.message,
            type: "danger",
          });
        }
        if (res.data.code === 1) {
          setEmail(res.data.data.email);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
  useEffect(() => {
    profileDetails();
  }, []);
  return (
    <div className="d-flex flex-column flex-root">
      <Alert />
      {/*begin::Page*/}
      <div className="page d-flex flex-row flex-column-fluid">
        {/*begin::Wrapper*/}
        <div
          className="wrapper d-flex flex-column flex-row-fluid"
          id="kt_wrapper"
        >
          <Header />
          <div className="app-body">
            <div className="w-100 p-5 custom-form-card">
              <div className="card my-4 my-xl-5 w-100 w-md-50 mx-auto">
                {/*begin::Card header*/}
                <div
                  className="card-header border-0 cursor-pointer"
                  role="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#kt_account_profile_details"
                  aria-expanded="true"
                  aria-controls="kt_account_profile_details"
                >
                  {/*begin::Card title*/}
                  <div className="card-title m-0">
                    <h3 className="fw-bold m-0">Profile Settings</h3>
                  </div>
                  {/*end::Card title*/}
                </div>
                {/*begin::Card header*/}

                {/*begin::Content*/}
                <div
                  id="kt_account_settings_profile_details"
                  className="collapse show"
                >
                  {/*begin::Form*/}
                  <form
                    id="kt_account_profile_details_form"
                    className="form"
                    onSubmit={updateEmail}
                  >
                    {/*begin::Card body*/}
                    <div className="card-body border-top p-9">
                      {/*begin::Input group*/}
                      <div className="row mb-6">
                        {/*begin::Label*/}
                        <label className="col-lg-12 col-form-label required fw-semibold">
                          Email Address
                        </label>
                        {/*end::Label*/}

                        {/*begin::Col*/}
                        <div className="col-lg-12 mb-3 mb-lg-0">
                          <input
                            type="text"
                            className="form-control form-control-lg form-control-solid"
                            placeholder="Update Your Email"
                            value={email}
                            onChange={(e) => {
                              setEmail(e.target.value);
                              setEmailError("");
                            }}
                          />
                          {emailError && emailError !== "" ? (
                            <div className="text-danger text-small">
                              {emailError}
                            </div>
                          ) : (
                            ""
                          )}
                        </div>
                        {/*end::Col*/}
                      </div>
                      {/*end::Input group*/}
                    </div>
                    {/*end::Card body*/}

                    {/*begin::Actions*/}
                    <div className="card-footer d-flex justify-content-end py-6 px-9">
                      <button
                        onClick={() => {
                          setEmail("");
                          setEmailError("");
                        }}
                        type="reset"
                        className="btn btn-light btn-active-light-primary me-2"
                      >
                        Reset
                      </button>
                      <button
                        type="submit"
                        className="btn btn-primary"
                        id="kt_account_profile_details_submit"
                      >
                        Save Changes
                      </button>
                    </div>
                    {/*end::Actions*/}
                  </form>
                  {/*end::Form*/}
                </div>
                {/*end::Content*/}
              </div>
            </div>
          </div>

          <Footer />
        </div>
        {/*end::Wrapper*/}
      </div>
      {/*end::Page*/}
    </div>
  );
};

export default ProfileSettings;
